module.exports = __webpack_public_path__ + "img/fees.47404a2c.png";